import React from "react";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";
import { mergeStyleSets, nuOrderTheme as theme, ConfirmDialog } from "@nuorder/components";
import { DialogTitle } from "containers/folders/containers/space-manager/components/manage-access/dialog-title";

interface IOwnProps {
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    isLoading?: boolean;
    selectedPermission: nuorder.folder.v1.Permission;
    isBlocking?: boolean;
    disableConfirm?: boolean;
    errorMessage: string;
}

export const DeletePermissionDialog: React.FunctionComponent<IOwnProps> = ({
    open,
    onConfirm,
    onClose,
    selectedPermission,
    isLoading,
    isBlocking,
    disableConfirm,
    errorMessage,
}) => {
    const classes = React.useMemo(
        () =>
            mergeStyleSets({
                errorMessage: {
                    fontSize: 14,
                    color: theme.palette.redDark,
                    wordBreak: "break-word",
                },
            }),
        []
    );

    return (
        <ConfirmDialog
            contentProps={{
                title: (
                    <DialogTitle
                        iconName="alertCircle24"
                        mainTitle={formatMessage("Remove Access")}
                        iconColor={theme.palette.errorBase}
                    />
                ) as any,
                subText: formatMessage("Are you sure you want to remove access for this user?"),
            }}
            open={open}
            onConfirm={onConfirm}
            onClose={onClose}
            confirmButtonDisabled={disableConfirm}
            isLoading={isLoading}
            isBlocking={isBlocking}
            okLabel={formatMessage("Yes, Remove")}
            cancelLabel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
        >
            {!!errorMessage && (
                <div data-test={DATATEST.FOLDERS.DIALOG.ERROR} className={classes.errorMessage}>
                    {errorMessage}
                </div>
            )}
        </ConfirmDialog>
    );
};
